module.exports = __webpack_public_path__ + "img/home-title.612c2811.png";